import { render, staticRenderFns } from "./resourcePlanning.vue?vue&type=template&id=2ddc1805&scoped=true&"
import script from "./resourcePlanning.vue?vue&type=script&lang=js&"
export * from "./resourcePlanning.vue?vue&type=script&lang=js&"
import style0 from "./resourcePlanning.vue?vue&type=style&index=0&id=2ddc1805&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ddc1805",
  null
  
)

export default component.exports